import { faChevronLeft, faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "reactstrap";
import "./style/FormStatus.scss";

const FormStatus = (props) => {
	const {
		onClick,
		formStatus,
		id,
		className,
		title,
		informationIcon,
		setmodalShow,
		navigateBack,
		weeklyView,
	} = props;
	return (
		<>
			{weeklyView ? (
				<div class="bottomMargin row">
					<div class="col-lg-6 col-md-6 col-sm-12 mr-auto heading">
						Time Logged for the Week
						<span class="m-3 vertical-line"></span>
						{formStatus && (
							<>
								{(() => {
									switch (formStatus) {
										case "Pending":
											return (
												<span
													className="ml-0 status-box status-pending"
													title="Status"
												>
													{formStatus}
												</span>
											);
										case "InProgress":
											return (
												<span
													className="ml-0 status-box status-pending"
													title="Status"
												>
													{"In Progress"}
												</span>
											);
										case "In Progress":
											return (
												<span
													className="ml-0 status-box status-pending"
													title="Status"
												>
													{"In Progress"}
												</span>
											);
										case "Completed":
											return (
												<span
													className="ml-0 status-box status-approved"
													title="Status"
												>
													{formStatus}
												</span>
											);
										case "Approved":
											return (
												<span
													className="ml-0 status-box status-approved"
													title="Status"
												>
													{formStatus}
												</span>
											);
										case "PM Approved":
											return (
												<span
													className="ml-0 status-box status-approved"
													title="Status"
												>
													{formStatus}
												</span>
											);
										case "Rejected":
											return (
												<span
													className="ml-0 status-box status-rejected"
													title="Status"
												>
													{formStatus}
												</span>
											);
										case "Reject":
											return (
												<span
													className="ml-0 status-box status-rejected"
													title="Status"
												>
													{formStatus}
												</span>
											);
										case "PM Rejected":
											return (
												<span
													className="ml-0 status-box status-rejected"
													title="Status"
												>
													{formStatus}
												</span>
											);
										case "Invalid":
											return (
												<span
													className="ml-0 status-box status-invalid"
													title="Status"
												>
													{formStatus}
												</span>
											);
										case "Submitted":
											return (
												<span
													className="ml-0 status-box status-Paid"
													title="Status"
												>
													{formStatus}
												</span>
											);
										default:
											return (
												<span
													className="ml-0 status-box status-draft"
													title="Status"
												>
													{formStatus}
												</span>
											);
									}
								})()}
							</>
						)}
					</div>
				</div>
			) : (
				<div className={`topBar formStatusBorder ${className} `}>
					<div className="d-flex align-items-center">
						{/*Navigation button*/}
						{navigateBack && (
							<Button
								title="Go Back"
								type="button"
								className="backBtn ml-n1"
								onClick={onClick}
							>
								<FontAwesomeIcon
									icon={faChevronLeft}
									size="1x"
								/>
							</Button>
						)}

						{/*Form Title*/}
						{id ? (
							title ? (
								<div className="mt-2 mt-md-0 ml-3 title">
									{title}
								</div>
							) : (
								<div className="mt-2 mt-md-0 ml-3  title">
									Requested Item
								</div>
							)
						) : title ? (
							<div className="mt-2 mt-md-0 ml-3 title">
								{title}
							</div>
						) : (
							<div className="mt-2 mt-md-0 ml-3 title">
								Create new request
							</div>
						)}

						{/*Switch case to handle Status Colors and Title*/}
						{formStatus && (
							<div>
								{(() => {
									switch (formStatus) {
										case "Pending":
											return (
												<div
													className="status-box status-pending"
													title="Status"
												>
													{formStatus}
												</div>
											);
										case "InProgress":
											return (
												<div
													className="status-box status-pending"
													title="Status"
												>
													{"In Progress"}
												</div>
											);
										case "In Progress":
											return (
												<div
													className="status-box status-pending"
													title="Status"
												>
													{"In Progress"}
												</div>
											);
										case "Completed":
											return (
												<div
													className="status-box status-approved"
													title="Status"
												>
													{formStatus}
												</div>
											);
										case "Approved":
											return (
												<div
													className="status-box status-approved"
													title="Status"
												>
													{formStatus}
												</div>
											);
										case "PM Approved":
											return (
												<div
													className="status-box status-approved"
													title="Status"
												>
													{formStatus}
												</div>
											);
										case "Rejected":
											return (
												<div
													className="status-box status-rejected"
													title="Status"
												>
													{formStatus}
												</div>
											);
										case "Reject":
											return (
												<div
													className="status-box status-rejected"
													title="Status"
												>
													{formStatus}
												</div>
											);
										case "PM Rejected":
											return (
												<div
													className="status-box status-rejected"
													title="Status"
												>
													{formStatus}
												</div>
											);
										case "Invalid":
											return (
												<div
													className="status-box status-invalid"
													title="Status"
												>
													{formStatus}
												</div>
											);
										case "Paid":
											return (
												<div
													className="status-box status-Paid"
													title="Status"
												>
													{formStatus}
												</div>
											);
										default:
											return (
												<div
													className="status-box status-draft"
													title="Status"
												>
													{formStatus}
												</div>
											);
									}
								})()}
							</div>
						)}
					</div>
					<div>
						{informationIcon ? (
							<span onClick={setmodalShow} className="imp-info">
								<FontAwesomeIcon
									icon={faInfo}
									className="fas fa-info-circle exclamation-icon"
								/>
							</span>
						) : null}
					</div>
				</div>
			)}
		</>
	);
};

export default FormStatus;
